import {configureStore} from "@reduxjs/toolkit";
import consumerSubscriptionsReducer from "../redux/slices/consumerSubscriptionSlice"
import documentReducer from "./slices/documentSlice";
import aiTemplateReducer from "./slices/AiTemplateSlice";
import rubricReducer from "./slices/RubricSlice";
import largeLanguageModelReducer from "./slices/AiLargeLanguageModelSlice";
import organizationReducer from "./slices/OrganizationSlice";
import waPackageReducer from "./slices/WaPackageSlice";
import resourceReducer from "./slices/ResourceSlice";
import tagReducer from "./slices/TagSlice";

export const store = configureStore({
    reducer: {
        // stripeSessionPaymentInfo: stripePaymentSliceReducer,
        consumerSubscriptions: consumerSubscriptionsReducer,
        document: documentReducer,
        aiTemplates: aiTemplateReducer,
        rubrics: rubricReducer,
        largeLanguageModels: largeLanguageModelReducer,
        organizations: organizationReducer,
        waPackages: waPackageReducer,
        resources: resourceReducer,
        tags: tagReducer,
    }
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch